module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1133.9c933265.png";